import { OrderStepModel } from "models";

const sidebar = {
  app: "میزکار",
  OrderModel: "سفارشات",
  StateModel: "استان‌ها",
  CityModel: "شهرها",
  OrderCreation: "ثبت سفارش",
  DoctorModel: "پزشکان",
  PatientModel: "بیماران",
  OperatorModel: "کاربران",
  LabActionCost: "تعرفه ها",
  LabModel: "لابراتوار ها",
  UnitModel: "کلینیک ها",
  UserModel: "کاربران",
  OrderStepModel: "مراحل سفارش",
  LabStepModel: "فرایندهای لابراتوار",
  PlanModel: "طرح های فروش",
  ActionsModel: "خدمات و تعرفه ها",

  doctors: "پزشکان",
  patients: "بیماران",
  services: "خدمات",
  labs: "لابراتور ها",
  units: "کلینیک ها",
  ordersList: "لیست سفارشات",
};
export default sidebar;
